import React, { useEffect } from "react";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import SelectedTab from "../../../../Components/Common/Tabs/SelectedTabs/SelectedTab";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader } from "reactstrap";
import { resetFormState } from "../../../../slices/common/reducer";
import { changeActiveTab } from "../../../../slices/oem/oemSlice";
import Details from "./Details";

const SelectedOem = () => {
  const dispatch = useDispatch();
  const tabs = useSelector((state) => state.oem.selectedOem.tabs);
  const activeTab = useSelector((state) => state.oem.selectedOem.activeTab);

  const formState = useSelector((state) => state.common.formRendererState);
  const data = useSelector((state) => state.oem.selectedOem.detailsData);

  useEffect(() => {
    return () => {
      dispatch(resetFormState());
      dispatch(changeActiveTab("details"));
    };
  }, [dispatch]);

  const breadcrumbItems = [
    { title: "PROD", link: "" },
    { title: "OEM", link: "/team/role" },
    { title: `${data.code}`, link: "/team/role/update" },
  ];

  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />
        <Card className="details-wrapper">
          <CardHeader>
            <SelectedTab
              tabs={tabs}
              activeTab={activeTab}
              changeActiveTab={changeActiveTab}
            />
          </CardHeader>
          {activeTab === "details" && <Details />}
        </Card>
      </div>
    </>
  );
};

export default SelectedOem;
